import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';

const fadeOutFrames = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const fadeInFrames = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeIn = css`
  animation: ${fadeInFrames} 500ms;
`;
const fadeOut = css`
  animation: ${fadeOutFrames} 500ms;
`;

const SlideContainer = styled.div`
  display: ${({ isActive }) => (isActive ? 'flex' : 'none')};
  padding: 44px 0;
  ${({ isActive }) => (isActive ? fadeIn : fadeOut)};
`;

const CarouselSlide = (props) => {
  const { children, isActive } = props;

  return <SlideContainer isActive={isActive}>{children}</SlideContainer>;
};

CarouselSlide.propTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
};

CarouselSlide.defaultProps = {
  isActive: false,
};

export default CarouselSlide;
